import gql from "fraql";

export const AppPrintEntityCompetitionResultsTemplateFragments = {
  personFields: gql`
    fragment _ on Person {
      id
      name
      feiid
      identifier
      identifierMasked
    }
  `,
  horseFields: gql`
    fragment _ on Horse {
      id
      name
      feiid
      ueln
      chipNumber
      dateOfBirth
      breedingStudbookId
      breedingStudbook @client {
        id
        name
      }
    }
  `
};
